import {
  ApplicationLifecycleStatus,
  type ApplicationLifecycleStatus as SharedApplicationLifecycleStatus,
  type WorkResponsibilityParty,
} from '@staff/shared'

export const DistributorApplicationLifecycleStatus = ApplicationLifecycleStatus
export type DistributorApplicationLifecycleStatus = SharedApplicationLifecycleStatus

export const DistributorApplicationType = {
  newLoanApplication: 'newLoanApplication',
  transferLoanApplication: 'transferLoanApplication',
  commitmentApplication: 'commitmentApplication',
  topupLoanApplication: 'topupLoanApplication',
} as const

export type DistributorApplicationType = (typeof DistributorApplicationType)[keyof typeof DistributorApplicationType]

export interface DistributorApplicationListQuery {
  page?: number
  hitsPerPage?: number
  status?: DistributorApplicationLifecycleStatus
  type?: DistributorApplicationType
  hasUnreadMessages?: boolean
  hasOpenConversations?: boolean
  hasOpenRequiredAdditions?: boolean
  isHighPrio?: boolean
  workResponsibilityParty?: WorkResponsibilityParty
  orderBy?: 'submitted_at' | 'work_responsibility_since'
  orderDirection?: 'asc' | 'desc'
}

export interface DistributorApplicationListItem {
  id: string
  publicId: number
  type: DistributorApplicationType
  status: DistributorApplicationLifecycleStatus
  amountAppliedFor: number | null
  amountApproved: number | null
  brokerExternalId?: string | null
  createdAt?: string | null
  updatedAt?: string | null
  submittedAt: string | null
  workResponsibilityParty: WorkResponsibilityParty | null
  workResponsibilitySince: string | null
  mainApplicant: {
    userId: string | null
    givenName: string | null
    surname: string | null
  }
  isHighPrio: boolean
  hasUnreadMessages: boolean
  hasOpenConversations: boolean
  hasOpenRequiredAdditions: boolean
}

export interface DistributorApplicationListResponse {
  hits: DistributorApplicationListItem[]
  page: number
  hitsPerPage: number
  nbHits: number
  nbPages: number
}
